import { useFetcher } from '@remix-run/react';
import { useEffect } from 'react';

import getNormalizedCategory from '~/utils/getNormalizedCategory';

interface Props {
  category: string;
}

const useCategoryPosts = ({ category }: Props) => {
  const fetcher = useFetcher();

  useEffect(() => {
    fetcher.load(`/t/${getNormalizedCategory(category)}`);
  }, []);

  return {
    isLoading: !fetcher?.data,
    posts: fetcher?.data?.paginatedPosts.posts,
  };
};

export default useCategoryPosts;
